<div>
  <div *ngIf="hasFilter"  class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body p-t-0 p-b-0">
          <div class="row">
            <div class="col-lg-3">
              <div class="form-group">
                <label for="manager" class="control-label col-form-label">Responsabile</label>
                <ng-multiselect-dropdown required [settings]="utentidropdownSettings" [placeholder]="'Seleziona'" name="manager"
                  [data]="managers" [(ngModel)]="managerselezionati"  (onFilterChange)="filtroResponsabile($event)" (ngModelChange)="refreshTable(1)">
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group">
                <label for="inizio" class="control-label col-form-label">Inizio</label>
                <input id="inizio" required [(ngModel)]="filtri.inizio" (ngModelChange)="refreshTable(1)" class="form-control" type="date">
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group">
                <label for="fine" class="control-label col-form-label">Fine</label>
                <input id="fine" required [(ngModel)]="filtri.fine" (ngModelChange)="refreshTable(1)" class="form-control" type="date">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="hasHeader"  class="d-md-flex align-items-center bg-white p-3">
    <span class="d-flex align-items-center p-2 ">
      <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> Task:</h5>
      <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
    </span>
    <div *ngIf="hasAddButton || (ModificheAbilitate && ((permission.isPermitted('gestione-fasi') && permission.isPermitted('gestione-progetti')) || permission.hasOperativeRole('PM')))" class="ml-auto mt-3 mt-md-0">
      <button type="button" class="btn btn-cyan rounded-pill py-2" (click)='add()'><i
          class="fas fa-plus  font-14 mr-1 text-white"></i>
        <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
      </button>
    </div>
  </div>
  <div *ngIf="!Cliente"  class="table-responsive">
    <table class="table bg-white table-hover align-middle mb-0 ">
      <thead>
        <tr>
          <th scope="col" *ngIf="hasFilter">Cliente</th>
          <th scope="col">Attività</th>
          <th scope="col" *ngIf="hasFilter">Offerta</th>
          <th scope="col">Stato</th>
          <th scope="col">Tipo</th>
          <th scope="col">Data inizio prevista</th>
          <th scope="col">Data inizio effettiva</th>
<!--          <th scope="col">Note</th>-->
          <th scope="col" *ngIf="ModificheAbilitate && (permission.isPermitted('gestione-fasi') || permission.hasOperativeRole('RF') || permission.hasOperativeRole('PM') || permission.hasOperativeRole('PF'))" >Azioni</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of Interventi | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
          <td class="align-middle" (click)='edit(item)' *ngIf="hasFilter">
            <span>
              <span >{{ item?.clienteObject?.nominativo ?? ""}}</span>

            </span>
          </td>
          <td class="align-middle" (click)='edit(item)' >
            <span>
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i class="fas " [class.fa-wrench]="true"></i>
              </span>
              {{item.nome}}
            </span>
          </td>
          <td class="align-middle" (click)='edit(item)' *ngIf="hasFilter">
            <span>
              <span >{{ item?.progettoObject?.oggetto ?? ""}}</span>
            </span>
          </td>
          <td class="align-middle" (click)='edit(item)'>
            <span>
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i class="fas fa-fast-forward"></i>
              </span>
              <span *ngIf="item.statoObject" >{{ item.statoObject.label}}</span>

            </span>
          </td>
          <td class="align-middle" (click)='edit(item)'>
            <span>
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i-feather name="info" class="feather-sm"></i-feather>
              </span>
              <span *ngIf="item.tipoObject" >{{ item.tipoObject.label}}</span>
            </span>
          </td>
          <td class="align-middle" (click)='edit(item)'>
            <span>
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i class="fas fa-calendar-plus"></i>
              </span>
              {{ item.data_inizio_prevista | date: 'dd/MM/yyyy'}}
            </span>
          </td>
          <td class="align-middle" (click)='edit(item)'>
            <span>
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i class="fas fa-calendar-check"></i>
              </span>
              <span>
                {{ item.data_inizio_effettiva | date: 'dd/MM/yyyy'}}
              </span>
            </span>
          </td>
<!--          <td class="align-middle" (click)='edit(item)'>-->
<!--            <span>-->
<!--              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
<!--                <i class="far fa-sticky-note"></i>-->
<!--              </span>-->
<!--              {{ item.note }}-->
<!--            </span>-->
<!--          </td>-->
          <td class="align-middle" *ngIf="ModificheAbilitate && (permission.isPermitted('gestione-fasi') || permission.hasOperativeRole('RF') || permission.hasOperativeRole('PM') || permission.hasOperativeRole('PF'))">
            <a href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
              (click)='edit(item)'>
              <i-feather name="edit-3" class="feather-sm"></i-feather>
            </a>
            <a href="javascript:void(0)" ngbTooltip="Elimina" *ngIf="permission.isPermitted('gestione-fasi')|| permission.hasOperativeRole('PM') || (item.padre && item?.manager?.id == authSvc?.currentUserValue?.id )" class="link font-16 text-danger font-weight-bold"
              (click)='delete(item)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="Cliente"  class="table-responsive">
    <table class="table bg-white table-hover align-middle mb-0 ">
      <thead>
        <tr>
          <th>Codice Offerta</th>
          <th scope="col">Impianto</th>
          <th scope="col">Intervento</th>
          <th scope="col">Tipo</th>
          <th scope="col">Data inizio prevista</th>
          <th scope="col">Data inizio effettiva</th>
          <th scope="col" *ngIf="ModificheAbilitate && permission.isPermitted('gestione-fasi')" >Azioni</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of Interventi | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
          <td class="align-middle" (click)='edit(item)'>
            <span>
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i class="fas fa-wrench"></i>
              </span>
              {{item.codice}}
            </span>
          </td>
          <td class="align-middle" (click)='edit(item)'>
            <span>
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i class="fas fa-wrench"></i>
              </span>
              {{item.oggetto}}
            </span>
          </td>
          <td class="align-middle" (click)='edit(item)'>
            <span>
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i class="fas fa-wrench"></i>
              </span>
              {{item.nome}}
            </span>
          </td>
          <td class="align-middle" (click)='edit(item)'>
            <span>
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i-feather name="info" class="feather-sm"></i-feather>
              </span>
              <span *ngIf="item.tipoObject" >{{ item.tipoObject.label}}</span>
            </span>
          </td>
          <td class="align-middle" (click)='edit(item)'>
            <span>
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i class="fas fa-calendar-plus"></i>
              </span>
              {{ item.data_inizio_prevista | date: 'dd/MM/yyyy'}}
            </span>
          </td>
          <td class="align-middle" (click)='edit(item)'>
            <span>
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i class="fas fa-calendar-check"></i>
              </span>
              <span>
                {{ item.data_inizio_effettiva | date: 'dd/MM/yyyy'}}
              </span>
            </span>
          </td>
          <td class="align-middle" *ngIf="ModificheAbilitate && permission.isPermitted('gestione-fasi')">
            <a href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
              (click)='edit(item)'>
              <i-feather name="edit-3" class="feather-sm"></i-feather>
            </a>
            <a href="javascript:void(0)" ngbTooltip="Elimina" class="link font-16 text-danger font-weight-bold"
              (click)='delete(item)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
    <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
      [collectionSize]="collectionSize" [pageSize]="pageSize">
    </ngb-pagination>
  </div>
</div>
